// src/components/dlog/DlogPage.tsx
import React, { useState, useCallback } from 'react';
import DlogUploader from './DlogUploader';
import DlogTable from './DlogTable';
import DlogViewer from './DlogViewer';
import { DlogItem } from '../../models/Dlog';
import './Dlog.css';

const DlogPage: React.FC = () => {
  const [dlogItems, setDlogItems] = useState<DlogItem[]>([]);
  const [selectedLog, setSelectedLog] = useState<DlogItem | null>(null);

  const handleLogLoaded = useCallback((newItem: DlogItem) => {

    setDlogItems((prevItems) => {
        newItem.index = prevItems.length + 1; // Set the index
        // console.log(`Adding item with index: ${newItem.index}, Total items will be: ${prevItems.length + 1}`);

        // Select the newly added item *after* it's fully constructed
        // Note: Setting state here inside the updater might feel odd,
        // but it ensures selectedLog gets the item with the correct index.
        // A useEffect watching dlogItems might be cleaner if selection logic grows.
        setSelectedLog(newItem);
        return [...prevItems, newItem];
    });

    // Optionally select the newly loaded item
    // setSelectedLog(newItem);
  }, []);

  const handleLogSelect = useCallback((logItem: DlogItem | null) => {
    setSelectedLog(logItem);
  }, []);

 const handleLogRename = useCallback((id: string, newName: string) => {
    setDlogItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, name: newName } : item
      )
    );
    // Update selected log if it was the one renamed
    if (selectedLog?.id === id) {
        setSelectedLog((prevSelected) => prevSelected ? { ...prevSelected, name: newName } : null);
    }
 }, [selectedLog]);


  return (
    <div className="dlog-page">
      <h2>Dlog - Log Analysis</h2>
      <div className="dlog-main-layout">
        <div className="dlog-table-and-uploader">
          <DlogTable
            dlogItems={dlogItems}
            selectedLogId={selectedLog?.id ?? null}
            onLogSelect={handleLogSelect}
            onLogRename={handleLogRename}
          />
          <DlogUploader onLogLoaded={handleLogLoaded} />
        </div>
        {selectedLog && <DlogViewer selectedLog={selectedLog} maxLines={200} />}
      </div>
    </div>
  );
};

export default DlogPage;
